import { Button } from "@/components/ui/button";

export function EmptyState({ icon: Icon, title, description, actionLabel, onAction, disabled, testid }) {
  return (
    <div
      className="border-2 border-dashed border-slate-200 rounded-xl p-10 text-center bg-white flex flex-col items-center gap-3"
      data-testid={testid || "empty-state"}
    >
      {Icon && (
        <div className="w-12 h-12 rounded-full bg-slate-50 border border-slate-200 flex items-center justify-center">
          <Icon className="w-6 h-6 text-slate-400" />
        </div>
      )}
      <div>
        <p className="font-heading font-semibold text-slate-800">{title}</p>
        {description && <p className="text-sm text-slate-500 mt-1 max-w-sm mx-auto">{description}</p>}
      </div>
      {actionLabel && onAction && (
        <Button onClick={onAction} disabled={disabled} data-testid="empty-state-action" className="mt-1">
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
